import { render, staticRenderFns } from "./bars-list.vue?vue&type=template&id=4669316a&"
import script from "./bars-list.vue?vue&type=script&lang=ts&"
export * from "./bars-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports